"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var includes_1 = tslib_1.__importDefault(require("lodash/includes"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var MinMaxControl_1 = tslib_1.__importDefault(require("../configurationControls//MinMaxControl"));
var ConfigurationPanelContent_1 = tslib_1.__importDefault(require("./ConfigurationPanelContent"));
var ConfigSection_1 = tslib_1.__importDefault(require("../configurationControls/ConfigSection"));
var CheckboxControl_1 = tslib_1.__importDefault(require("../configurationControls/CheckboxControl"));
var DataLabelsControl_1 = tslib_1.__importDefault(require("../configurationControls/DataLabelsControl"));
var bubble_1 = require("../../constants/bubble");
var LabelSubsection_1 = tslib_1.__importDefault(require("../configurationControls/axis/LabelSubsection"));
var axis_1 = require("../../constants/axis");
var sdk_model_1 = require("@gooddata/sdk-model");
var insightIntrospection_1 = require("../pluggableVisualizations/baseChart/insightIntrospection");
var NameSubsection_1 = tslib_1.__importDefault(require("../configurationControls/axis/NameSubsection"));
var BaseChartConfigurationPanel = /** @class */ (function (_super) {
    tslib_1.__extends(BaseChartConfigurationPanel, _super);
    function BaseChartConfigurationPanel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseChartConfigurationPanel.prototype.renderCanvasSection = function () {
        var gridEnabled = this.getControlProperties().gridEnabled;
        var _a = this.props, properties = _a.properties, propertiesMeta = _a.propertiesMeta, pushData = _a.pushData;
        var controlsDisabled = this.isControlDisabled();
        return (react_1.default.createElement(ConfigSection_1.default, { id: "canvas_section", title: "properties.canvas.title", propertiesMeta: propertiesMeta, properties: properties, pushData: pushData },
            react_1.default.createElement(DataLabelsControl_1.default, { pushData: pushData, properties: properties, isDisabled: controlsDisabled }),
            react_1.default.createElement(CheckboxControl_1.default, { valuePath: "grid.enabled", labelText: "properties.canvas.gridline", properties: properties, checked: gridEnabled, disabled: controlsDisabled, pushData: pushData })));
    };
    BaseChartConfigurationPanel.prototype.renderConfigurationPanel = function () {
        var axes = this.getControlProperties().axes;
        return (react_1.default.createElement(sdk_ui_kit_1.BubbleHoverTrigger, { showDelay: bubble_1.SHOW_DELAY_DEFAULT, hideDelay: bubble_1.HIDE_DELAY_DEFAULT },
            react_1.default.createElement("div", null,
                this.renderColorSection(),
                this.getBaseChartAxisSection(axes),
                this.renderLegendSection(),
                this.renderCanvasSection()),
            react_1.default.createElement(sdk_ui_kit_1.Bubble, { className: this.getBubbleClassNames(), arrowOffsets: { "tc bc": [bubble_1.BUBBLE_ARROW_OFFSET_X, bubble_1.BUBBLE_ARROW_OFFSET_Y] }, alignPoints: [{ align: "tc bc" }] },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "properties.config.not_applicable" }))));
    };
    BaseChartConfigurationPanel.prototype.getAxesConfiguration = function (type) {
        return axis_1.BASE_CHART_AXIS_CONFIG[type];
    };
    BaseChartConfigurationPanel.prototype.getControlProperties = function () {
        var _a, _b, _c, _d, _e;
        var props = this.props;
        var gridEnabled = (_d = (_c = (_b = (_a = props.properties) === null || _a === void 0 ? void 0 : _a.controls) === null || _b === void 0 ? void 0 : _b.grid) === null || _c === void 0 ? void 0 : _c.enabled) !== null && _d !== void 0 ? _d : true;
        var axisType = includes_1.default(axis_1.DUAL_AXES_SUPPORTED_CHARTS, props.type)
            ? (_e = props.axis) !== null && _e !== void 0 ? _e : axis_1.AXIS.PRIMARY : axis_1.AXIS.PRIMARY;
        var configurations = this.getAxesConfiguration(axisType);
        var axes = configurations.map(function (axis) {
            var _a, _b, _c, _d;
            return tslib_1.__assign(tslib_1.__assign({}, axis), { visible: (_d = (_c = (_b = (_a = props.properties) === null || _a === void 0 ? void 0 : _a.controls) === null || _b === void 0 ? void 0 : _b[axis.name]) === null || _c === void 0 ? void 0 : _c.visible) !== null && _d !== void 0 ? _d : true });
        });
        return {
            gridEnabled: gridEnabled,
            axes: axes,
        };
    };
    BaseChartConfigurationPanel.prototype.getBubbleClassNames = function () {
        return classnames_1.default("bubble-primary", {
            invisible: !this.isControlDisabled(),
        });
    };
    BaseChartConfigurationPanel.prototype.isViewedBy = function () {
        var insight = this.props.insight;
        return !sdk_model_1.bucketsIsEmpty(sdk_model_1.insightBuckets(insight, sdk_ui_1.BucketNames.VIEW, sdk_ui_1.BucketNames.TREND));
    };
    BaseChartConfigurationPanel.prototype.getBaseChartAxisSection = function (axes) {
        var _this = this;
        var _a = this.props, featureFlags = _a.featureFlags, type = _a.type, properties = _a.properties, propertiesMeta = _a.propertiesMeta, pushData = _a.pushData, insight = _a.insight;
        var controls = properties && properties.controls;
        var controlsDisabled = this.isControlDisabled();
        var isViewedBy = this.isViewedBy();
        var itemsOnAxes = insightIntrospection_1.countItemsOnAxes(type, controls, insight);
        var isNameSubsectionVisible = featureFlags.enableAxisNameConfiguration;
        var isAxisLabelsFormatEnabled = featureFlags.enableAxisLabelFormat;
        return axes.map(function (axis) {
            var disabled = controlsDisabled || (!axis.primary && !isViewedBy);
            var hasMoreThanOneItem = itemsOnAxes[axis.name] > 1;
            var name = axis.name, title = axis.title, subtitle = axis.subtitle, visible = axis.visible;
            return (react_1.default.createElement(ConfigSection_1.default, { key: name, id: name + "_section", title: title, subtitle: subtitle, valuePath: name + ".visible", canBeToggled: true, toggledOn: visible, toggleDisabled: controlsDisabled, propertiesMeta: propertiesMeta, properties: properties, pushData: pushData },
                isNameSubsectionVisible && (react_1.default.createElement(NameSubsection_1.default, { disabled: disabled || hasMoreThanOneItem, configPanelDisabled: controlsDisabled, axis: axis.name, properties: properties, pushData: pushData })),
                react_1.default.createElement(LabelSubsection_1.default, { disabled: disabled, configPanelDisabled: controlsDisabled, axis: axis.name, properties: properties, pushData: pushData, showFormat: axis.primary && isAxisLabelsFormatEnabled }),
                axis.primary && _this.renderMinMax(axis.name)));
        });
    };
    BaseChartConfigurationPanel.prototype.renderMinMax = function (basePath) {
        var _a = this.props, pushData = _a.pushData, properties = _a.properties, propertiesMeta = _a.propertiesMeta;
        return (react_1.default.createElement(MinMaxControl_1.default, { isDisabled: this.isControlDisabled(), basePath: basePath, pushData: pushData, properties: properties, propertiesMeta: propertiesMeta }));
    };
    return BaseChartConfigurationPanel;
}(ConfigurationPanelContent_1.default));
exports.default = BaseChartConfigurationPanel;
//# sourceMappingURL=BaseChartConfigurationPanel.js.map